import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import GiftFilledSvg from "@ant-design/icons-svg/es/asn/GiftFilled";
import AntdIcon from "../components/AntdIcon";
var GiftFilled = function GiftFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GiftFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  GiftFilled.displayName = 'GiftFilled';
}
export default /*#__PURE__*/React.forwardRef(GiftFilled);